export default "__VITE_ASSET__56cf7d15__"